// extracted by mini-css-extract-plugin
module.exports = {"modal":"FeedModalEdit_modal__26l7C","outside":"FeedModalEdit_outside__3E7OI"};